










































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import GoBackWithCloseTabMixin from '@/common/mixins/go-back-with-close-tab';
import moment from 'moment';
import { TreeSelect } from 'ant-design-vue';
// import { DEFAULT_DATE_FORMAT } from '@/common/config'
import { CHANNEL_LIST } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';
import { dictWeekMap, dictWeekDateMap } from '@/types/parking-lot-management/dictionaries';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
// import AreaListForm from '../../../utils/areaListForm.vue'
import Utils from '@/utils/common';
// axios请求
import { getCarType, channelForbid, getForbidCars, getForbidDetail } from '@/api/parking-lot-management/index';
import { debug } from 'webpack';

// form表单项定义
export interface IForm {
  carTypes: string;
  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  des: string;
  allowDay: string;
  date: any[];
  timeSlots: any[];
  // _d: any
}
@Component
// @Component
export default class channelGrant extends Mixins(TableMixin, TableWidthMixin, GoBackWithCloseTabMixin) {
  // queryAreaListDebounce: any = function() {} // 列表防抖请求
  headTitle = '通道授权';
  carTypes: any[] = [];
  channelId = '';
  areaId: string = '';
  parkId = '';
  data = '';
  dataForm: any = {};

  @Watch('timeSlot', { immediate: true, deep: true })
  onTimeSlotChanged(newData: any[]) {
    const returnValue =
      newData.length == 1 &&
      +moment(newData[0].startTime._d)
        .format('HH:mm:ss')
        .replace(/:/g, '') == 0 &&
      +moment(newData[0].endTime._d)
        .format('HH:mm:ss')
        .replace(/:/g, '') == 0;

    this.hasPopConfirmWhenHMSRangeEmpty = returnValue;
  }

  hasPopConfirmWhenHMSRangeEmpty = false;
  form: any = null;
  weekDates = '';
  startDate = '';
  endDate = '';
  allowDay = [];
  timeSlot = [
    {
      startTime: moment('00:00:00', 'HH:mm:ss'),
      endTime: moment('00:00:00', 'HH:mm:ss')
    }
  ];
  timeSlots: any[] = [];
  // 星期
  weekOptions = [
    { title: '星期一', value: '1', key: '1' },
    { title: '星期二', value: '2', key: '2' },
    { title: '星期三', value: '3', key: '3' },
    { title: '星期四', value: '4', key: '4' },
    { title: '星期五', value: '5', key: '5' },
    { title: '星期六', value: '6', key: '6' },
    { title: '星期日', value: '7', key: '7' }
  ];
  // 授权星期,多个日期逗号拼接，如“1，2，3，4，5，6，7”
  // weekOptions: IOption[] = Utils.toLabelVal(dictWeekMap)
  // 工作日周末全部
  weekDateOptions: IOption[] = Utils.toLabelVal(dictWeekDateMap);
  weekChange(e: any) {
    this.allowDay = e.target.value.split(',');
  }
  dayChange(e: any) {
    this.weekDates = e.join(',');
  }
  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '通道信息',
        location: {
          name: CHANNEL_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }

  async created() {
    const { areaId, parkId } = this.$route.query;
    // this.parkId = this.$route.query.parkId
    this.channelId = this.$route.params.channelId;
    await this.querygetForbidDetail();
  }
  //获取数据
  async querygetForbidDetail() {
    try {
      const { data, code, msg, status } = await getForbidDetail({ channelId: this.$route.params.channelId });
      if (data && data.carTypes) {
        // @ts-ignore
        this.isEdit = true;
        this.dataForm = data;
        this.allowDay = data.allowDay.split(',') || [];
        this.dataForm.carTypes = data.carTypes.split(',') || [];
        this.dataForm.date = [moment(`${data.startDate}`, 'YYYY-MM-DD'), moment(`${data.endDate}`, 'YYYY-MM-DD')];
        const timeSlotdp = data.time.map((item: { startTime: any; endTime: any }) => {
          return { startTime: moment(`${item.startTime}`, 'HH:mm:ss'), endTime: moment(`${item.endTime}`, 'HH:mm:ss') };
        });
        this.timeSlot = timeSlotdp || [
          {
            startTime: moment('00:00:00', 'HH:mm:ss'),
            endTime: moment('00:00:00', 'HH:mm:ss')
          }
        ];
      } else {
        // @ts-ignore
        this.isEdit = false;
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.init();
      this.getCarTypeList();
    }
  }
  // 初始化form表单
  init() {
    if (this.isEdit) {
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          const { carTypes, startDate, endDate, startTime, endTime, des, allowDay, timeSlots, date } = this.dataForm;
          return {
            date: this.$form.createFormField({
              value: date
            }),
            carTypes: this.$form.createFormField({
              value: carTypes
            }),
            startDate: this.$form.createFormField({
              value: startDate
            }),
            startTime: this.$form.createFormField({
              value: startTime
            }),
            endDate: this.$form.createFormField({
              value: endDate
            }),
            endTime: this.$form.createFormField({
              value: endTime
            }),
            des: this.$form.createFormField({
              value: des
            }),
            allowDay: this.$form.createFormField({
              value: allowDay
            }),
            timeSlots: this.$form.createFormField({
              value: timeSlots
            })
          };
        }
      });
    } else {
      this.form = this.$form.createForm(this);
    }
  }
  async handleSubmit(e?: any) {
    e.preventDefault();
    this.form.validateFields(async (err: boolean, values: IForm) => {
      if (!err) {
        if (values.date) {
          this.startDate = moment(values.date[0]._d).format('YYYY-MM-DD');
          this.endDate = moment(values.date[1]._d).format('YYYY-MM-DD');
        } else {
          this.startDate = moment(new Date()).format('YYYY-MM-DD');
          this.endDate = moment('2099-12-31').format('YYYY-MM-DD');
        }

        // values.date
        // values.startTime = moment(values.startTime._d).format('HH:mm')
        // values.endTime = moment(values.endTime._d).format('HH:mm')
        // values.timeSlots.push({
        //   startTime: moment(values.startTime._d).format('HH:mm'),
        //   endTime: moment(values.endTime._d).format('HH:mm'),
        // })
        this.timeSlots = this.timeSlot.map((item: any) => {
          return {
            startTime: moment(item.startTime._d).format('HH:mm:ss'),
            endTime: moment(item.endTime._d).format('HH:mm:ss')
          };
        });
        let errorIndex = null,
          errorString,
          errorType = 'SELF';
        const timeHMS2Integer = (hmsStr: string) => new Date('1999-01-01 ' + hmsStr).getTime();
        const hasError = this.timeSlots.every((item, index, arr) => {
          let returnValue;
          if (index == this.timeSlots.length - 1) {
            returnValue = timeHMS2Integer(item.endTime) >= timeHMS2Integer(item.startTime);
            if (!returnValue) {
              errorType = 'SELF';
            }
          } else {
            returnValue =
              timeHMS2Integer(item.endTime) >= timeHMS2Integer(item.startTime) &&
              timeHMS2Integer(arr[index + 1].startTime) >= timeHMS2Integer(item.endTime);
            if (!returnValue) {
              errorType = 'SELF_AND_NEXT';
            }
          }

          if (!returnValue) {
            errorIndex = index;
            return false;
          }
        });

        if (errorIndex != null) {
          errorString =
            '授权时段第' +
            (errorIndex + 1) +
            '项的结束时间不能' +
            (errorType == 'SELF' ? '小' : '大') +
            '于' +
            (errorType == 'SELF' ? '' : '下一个时段的') +
            '开始时间';
          this.$message.error(errorString);
          return false;
        }

        // if (
        //   this.timeSlots.length == 1 &&
        //   this.timeSlots[0].startTime.replace(/:/g, '') == 0 &&
        //   this.timeSlots[0].endTime.replace(/:/g, '') == 0
        // ) {
        //   this.hasPopConfirmWhenHMSRangeEmpty = true
        // }

        // console.log('this.timeSlots--:', this.timeSlots,moment(new Date())).timeS
        values.allowDay = this.allowDay.join(',');
        const { areaId, parkId } = this.$route.query;

        this.setchannelForbid({
          ...values,
          areaId,
          parkId,
          channelId: this.channelId,
          timeSlots: this.timeSlots,
          startDate: this.startDate,
          endDate: this.endDate
        });
      }
    });
  }

  async setchannelForbid(values: any) {
    try {
      const { status, msg, code, data } = await channelForbid(values);
      if (status === '9999') {
        this.$message.success('设置成功');
        this.goBack();
      } else {
        this.$message.error(msg);
      }
    } catch (e) {
      // console.log(error)
      this.$message.error((e && e.msg) || '设置失败');
    }
  }
  delTime(index: number) {
    if (this.timeSlot.length > 1) {
      // this.timeSlot.pop()
      this.timeSlot.splice(index, 1);
    }
  }
  addTime() {
    this.timeSlot.push({
      startTime: moment('00:00:00', 'HH:mm:ss'),
      endTime: moment('00:00:00', 'HH:mm:ss')
    });
  }
  confirm() {
    this.handleSubmit();
  }
  cancel() {
    console.log('点击取消了');
  }
  compare(property) {
    return function(a, b) {
      //排序规则
      var rule = ['tempBig', 'tempSmall', 'newPowerBig', 'newPowerSmall', 'property'];
      return rule.indexOf(a[property]) - rule.indexOf(b[property]);
    };
  }
  //获取禁止通行车类列表
  async getCarTypeList() {
    try {
      const { status, msg, code, data } = await getForbidCars({ parkId: this.$route.query.parkId });
      if (status === '9999') {
        this.carTypes = [];
        for (let i in data) {
          this.carTypes.push(data[i]);
        }
        if (data.newPowerBig && data.newPowerSmall) {
          if (data.specialTypes.children.length < 1) {
            this.carTypes = [
              data.tempBig,
              data.tempSmall,
              data.newPowerBig,
              data.newPowerSmall,
              data.month,
              data.property
            ];
          } else {
            this.carTypes = [
              data.tempBig,
              data.tempSmall,
              data.newPowerBig,
              data.newPowerSmall,
              data.specialTypes,
              data.month,
              data.property
            ];
          }
        } else {
          if (data.specialTypes.children.length < 1) {
            this.carTypes = [data.tempBig, data.tempSmall, data.month, data.property];
          } else {
            this.carTypes = [data.tempBig, data.tempSmall, data.specialTypes, data.month, data.property];
          }
        }
      }
    } catch (e) {
      console.log(e);
      this.$message.error((e && e.msg) || '系统繁忙，请稍后再试');
    }
  }
  // // 返回
  // goBack() {
  //   this.$router.replace({
  //     name: CHANNEL_LIST,
  //   })
  // }
  /**
   * form布局
   */
  formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 14 }
    }
  };
  centerFormItemLayout = {
    wrapperCol: {
      xs: {
        span: 20,
        offset: 4
      },
      sm: {
        span: 14,
        offset: 10
      }
    }
  };
}
